
import { SendStoreLocatorForm, StoreLocatorTypeForm } from "@/interfaces";
import { computed, defineComponent, PropType, reactive, ref, watch } from "vue";
import { required, email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default defineComponent({
  name: "BecomeDealerForm",
  emits: ["update:modelValue", "submit"],
  props: {
    modelValue: {
      type: Object as PropType<SendStoreLocatorForm>,
      default: null,
    },
  },
  setup(props, { emit }) {
    const model = reactive<any>(
      props.modelValue || {
        name: "",
        lastname: "",
        email: "",
        telephone: "",
        province: "",
        city: "",
        organizationName: "",
        type: "",
        dealerType: StoreLocatorTypeForm.NoOne,
        vatNumber: "",
        notes: "",
      }
    );
    const checkboxes = reactive<any>({
      policy: false,
      terms: false,
    });

    const full = ref({ ...model, ...checkboxes });
    const rulesConfig = reactive<any>({
      name: {
        required,
      },
      lastname: {
        required,
      },
      email: {
        email,
        required
      },
      telephone: {
        required,
      },
      province: {
        required,
      },
      city: {
        required,
      },
      organizationName: {
        required,
      },
      type: {
        required,
      },
      vatNumber: {
        required,
      },
      dealerType: {
        requiredValidOption: (val: any) => {
          return val !== StoreLocatorTypeForm.NoOne;
        },
      },
      policy: {
        requiredChecked: (val: any) => {
          return val === true;
        },
      }
    });
    const v$ = useVuelidate(rulesConfig, full);

    const onChange = (e: any) => {
      v$.value[e.target.name as any].$touch();
      full.value[e.target.name as any] = e.target.value;
      model[e.target.name] = e.target.value;
      console.log(model);
      emit("update:modelValue", model);
    };

    const onSubmit = () => {
      emit("submit");
    };

    return {
      model: full,
      v$,
      onChange,
      onSubmit,
    };
  },
});
